/**************
 Header V2
 ***************/

const headerV2 = document.querySelector("#headerV2");
const sliderV2 = document.querySelector("#sliderV2");

if (headerV2) {
    const navLinks = headerV2.querySelectorAll(".headerV2NavLink");
    const megaPanels = headerV2.querySelectorAll(".headerV2MegaNav");
    let activeNavIndex = null;
    let closeTimeout = null;

    function openMegaNav(index) {
        clearTimeout(closeTimeout);

        navLinks.forEach((link) => {
            link.classList.toggle("is-active", link.dataset.navIndex === index);
        });

        megaPanels.forEach((panel) => {
            const isOpen = panel.dataset.navIndex === index;
            panel.classList.toggle("is-open", isOpen);
            panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
        });

        activeNavIndex = index;
    }

    function closeMegaNav() {
        navLinks.forEach((link) => link.classList.remove("is-active"));
        megaPanels.forEach((panel) => {
            panel.classList.remove("is-open");
            panel.setAttribute("aria-hidden", "true");
        });
        activeNavIndex = null;
    }

    function scheduleCloseMegaNav() {
        clearTimeout(closeTimeout);
        closeTimeout = setTimeout(closeMegaNav, 120);
    }

    navLinks.forEach((link) => {
        const index = link.dataset.navIndex;
        const panel = headerV2.querySelector(`.headerV2MegaNav[data-nav-index="${index}"]`);

        if (!panel) {
            return;
        }

        link.addEventListener("mouseenter", () => openMegaNav(index));
        link.addEventListener("mouseleave", scheduleCloseMegaNav);
        panel.addEventListener("mouseenter", () => openMegaNav(index));
        panel.addEventListener("mouseleave", scheduleCloseMegaNav);
    });

    headerV2.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
            closeMegaNav();
        }
    });
}

/**************
 Mobile Nav V2
 ***************/

if (sliderV2) {
    document.querySelectorAll(".sliderV2NavDropdownToggle").forEach((element) => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });

    function openNavV2() {
        sliderV2.showModal();
        document.querySelector("body").classList.add("noScroll");
    }

    sliderV2.addEventListener("close", function () {
        document.querySelector("body").classList.remove("noScroll");
    });

    async function closeNavV2() {
        sliderV2.close();
    }

    document.querySelectorAll(".openNavV2").forEach(function (element) {
        element.addEventListener("click", openNavV2);
    });

    document.querySelectorAll(".closeNavV2").forEach(function (element) {
        element.addEventListener("click", closeNavV2);
    });
}
